import {z} from 'zod';

/** RPT_get_monthlyStockTakeById_API. Amounts use the tenant currency. */
export const MonthlyStockTakeDetailResponseSchema = z
  .object({
    id: z.string().nullish(),
    closingMonth: z.string().nullish(),
    warehouseId: z.string().nullish(),
    warehouseName: z.string().nullish(),
    branchId: z.string().nullish(),
    branchName: z.string().nullish(),
    openingInventoryValue: z.number().nullish(),
    articlesWithValueStart: z.number().nullish(),
    closingInventoryValue: z.number().nullish(),
    articlesWithValueEnd: z.number().nullish(),
    inventoryValueDifference: z.number().nullish(),
    monthlyReceiptsValue: z.number().nullish(),
    receiptedArticlesCount: z.number().nullish(),
    monthlyIssuesValue: z.number().nullish(),
    issuedArticlesCount: z.number().nullish(),
    monthlyCorrectionsValue: z.number().nullish(),
    checkSum: z.number().nullish(),
    checkIsCorrect: z.boolean().nullish(),
    openingSourceDay: z.string().nullish(),
    receiptsFromSuppliers: z.number().nullish(),
    receiptsFromSuppliersCount: z.number().nullish(),
    transferToWarehouse: z.number().nullish(),
    transferToWarehouseCount: z.number().nullish(),
    materialReturns: z.number().nullish(),
    materialReturnsCount: z.number().nullish(),
    issuancesToOrders: z.number().nullish(),
    issueNotesToOrdersCount: z.number().nullish(),
    transferFromWarehouse: z.number().nullish(),
    transferFromWarehouseCount: z.number().nullish(),
    receiptNoteInProgress: z.number().nullish(),
    pendingGoodsPurchase: z.number().nullish(),
    pendingGoodsTransfer: z.number().nullish(),
    isContinuityOk: z.boolean().nullish(),
    continuityDifference: z.number().nullish(),
    averageInventoryValue: z.number().nullish(),
    inventoryTurnover: z.number().nullish(),
    inventoryDays: z.number().nullish(),
    averageArticleValue: z.number().nullish(),
    slowStock_3mValue: z.number().nullish(),
    slowStock_3mArticleCount: z.number().nullish(),
    slowStock_6mValue: z.number().nullish(),
    slowStock_6mArticleCount: z.number().nullish(),
    slowStock_12mValue: z.number().nullish(),
    slowStock_12mArticleCount: z.number().nullish(),
    slowStock_6mShare: z.number().nullish(),
    momDifferenceValue: z.number().nullish(),
    momDifferencePercent: z.number().nullish(),
    receiptsYtdValue: z.number().nullish(),
    issuesYtdValue: z.number().nullish(),
    inventoryAdjustmentValue: z.number().nullish(),
    inventoryDocCount: z.number().nullish(),
    inventoryArticleCount: z.number().nullish(),
    writeOffValue: z.number().nullish(),
    writeOffDocCount: z.number().nullish(),
    pendingIsReliable: z.boolean().nullish(),
  })
  .nullable();

export type MonthlyStockTakeDetailResponse = z.infer<typeof MonthlyStockTakeDetailResponseSchema>;
